import { SocketClient } from '@goldcast/client';
import store from '@/store';

export class GatewayClient extends SocketClient {
  constructor(url, logger) {
    super(url, logger, 'gatewaysocket');
  }

  preConnect() {
    this.logger.info('Running socket preConnect for gatewaysocket');
    const token = store.state?.user?.userCognitoDetails?.signInUserSession?.accessToken?.jwtToken;
    if (token && this.url) {
      const matches = this.url.match(/^(.*)\?access_token=.*$/);
      if (matches) {
        this.url = matches[1];
      }
      this.url += '?access_token=' + token;
      return Promise.resolve();
    } else {
      return new Promise((res, rej) => {
        setTimeout(() => {
          this.preConnect().then(res).catch(rej);
        }, 5000);
      });
    }
  }

  onError() {
    // @sachin save the socket status in the store somewhere and show an indicator on the page
    // online - green
    // offline - red
    // error - black
    // store.commit("apigateway/setSocketStatus", "error");
  }

  onMessage(event) {
    const message = JSON.parse(event.data);
    switch (message.event) {
      case 'broadcast-updated':
        store.dispatch('studioAgenda/broadcastGatewaySocketEvents', message);
        break;
      case 'agenda-item-updated':
        break;
      case 'rtmp-input-updated':
        store.dispatch('rtmpInputs/processRtmpInputChannelUpdatedSocketMsg', message);
        break;
      default:
        return;
    }
  }

  onOpened() {
    return store.dispatch('studioAgenda/processSocketOpenDone');
  }

  onClosed() {
    this.logger.warn('Socket has closed! Reconnecting!!');
  }

  sendMessageWithConnection(msg) {
    if (!this.openPromise) {
      this.connect();
    }
    this.sendMessage(msg);
  }
}
